import styled from 'styled-components';

export const NotifItem = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.mocaThinnerGrey};
  padding: 16px 0;
  cursor: pointer;
  position: relative;
  transition: .3s;
  
  &:hover {
    opacity: 0.7;
  }
`

export const NotifUnreadDot = styled.div`
  background-color: ${({theme}) => theme.unreadRed};
  width: 10px;
  height: 10px;
  border-radius: 100%;
  position: absolute;
  top: 16px;
  right: 0;
`
